// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","366":"1b19e89c","513":"dee3b43a","665":"eecd6c71","706":"cc727622"}[chunkId] + ".chunk.js";
};